























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class B2CConfiguration extends Vue {
  @Prop({ default: false }) readonly!: boolean
  // This component is a placeholder for future B2C configuration
}
